<template>
  <div class="testPlate">
    <div class="plate_modal_content">
      <div class="file_text">
        智能网联汽车测试牌照变更申请
      </div>
      <div class="frame-number">
        车架号：{{carInfo?.frameNum}}
      </div>
      <div class="plate-change-container">
        <!-- 左侧：原有数据 -->
        <div class="plate-section original-data">
          <h3>原测试牌照信息</h3>
          <div class="plate-item">
            <span class="label">测试牌照：</span>
            <span class="value">{{ carInfo?.testCarNum || '暂无数据' }}</span>
          </div>
          <div class="plate-item">
            <span class="label">牌照申请日期：</span>
            <span class="value">{{ carInfo?.plateApplyDateStr || '暂无数据' }}</span>
          </div>
          <div class="plate-item">
            <span class="label">牌照到期日期：</span>
            <span class="value">{{ carInfo?.plateExpireDateStr || '暂无数据' }}</span>
          </div>
        </div>

        <!-- 分隔线 -->
        <div class="separator"></div>

        <!-- 右侧：变更数据 -->
        <div class="plate-section new-data">
          <h3>新测试牌照信息</h3>
          <div class="plate-item">
            <span class="label required">测试牌照：</span>
            <a-input v-model:value="plateChangeRef.testCarNum" placeholder="请获取资质后填写测试车牌号" style="width: 100%;" />
          </div>
          <div class="plate-item">
            <span class="label required">牌照申领日期：</span>
            <a-date-picker v-model:value="plateChangeRef.plateApplyDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" style="width: 100%;" />
          </div>
          <div class="plate-item">
            <span class="label required">牌照到期日期：</span>
            <a-date-picker v-model:value="plateChangeRef.plateExpireDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" style="width: 100%;" />
          </div>
          <div class="plate-item">
            <span class="label required">牌照附件：</span>
            <image-uploader
                v-model:image-url="plateChangeRef.plateAttachmentUrl"
                :path-name="'license'"
                :box-width="180"
                :box-height="120"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="mt16 botmBtn">
      <a-button type="primary" ghost class="mr10" @click="props.onCancel">取消</a-button>
      <a-button type="primary" class="ml10" @click="plateConfirm">确定</a-button>
    </div>

    <div class="mt16 list">
      <div class="tit">牌照变更申请记录</div>

      <div class="modal_table">
        <div class="info">车辆测试牌照更新需审核通过后才能生效</div>
        <a-table v-if="plateChangeRecords" :columns="plateChangeApplyColumns" :row-key="(record) => record.applyTime" :data-source="plateChangeRecords"
                 size="middle" :pagination="false" :scroll="{ y:120}">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'applyTime'">
              {{ moment(record.applyTime).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
            <template v-if="column.key === 'checkOpinion'">
              {{record.checkResult===1?'通过':record.checkResult===0?'不通过':'待审核'}} <span v-if="record.checkResult">,</span>  {{record.checkOpinion }}
            </template>
            <template v-else-if="column.key === 'action'">
              <span><a @click="openChangeContentModal(record)" class="alink">查看变更详情</a></span>
              <span class="ml10" v-if="record.checkResult !==1"><a @click="closeChangeApply(record)" class="alink">撤销</a></span>
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <!-- 变更内容弹框 -->
    <ChangeContentModal
        v-model:visible="changeContentModalVisible"
        :currentRecord="currentChangeRecord"
        @cancel="handleChangeContentModalCancel"
    />
  </div>
</template>

<script setup>
import {ref, defineProps, defineEmits, computed} from 'vue';
import moment from 'moment';
import { Button as AButton, Input as AInput, DatePicker as ADatePicker, message, Modal } from 'ant-design-vue';
import ChangeContentModal from './plateChangeContentModal.vue';
import imageUploader from '@/components/imageUploader/index.vue'

const props = defineProps({
  changeInfo: {
    type: Object,
    default: () => {}
  },
  carInfo: {
    type: Object,
    default: () => {}
  },
  onCancel: {
    type: Function,
    required: true
  }
});

const plateChangeRecords = computed(() => {
  return props.changeInfo.records?.filter(record => record.type === 2) || [];
});

const emits = defineEmits(['plateChange', 'withdrawChange']);

const plateChangeRef = ref({
  testCarNum: '',
  plateApplyDateStr: null,
  plateExpireDateStr: null,
  plateAttachmentUrl: ''
});

const resetPlateChangeRef = () => {
  plateChangeRef.value = {
    testCarNum: '',
    plateApplyDateStr: null,
    plateExpireDateStr: null,
    plateAttachmentUrl: ''
  }
};

const changeContentModalVisible = ref(false);
const currentChangeRecord = ref(null);

const openChangeContentModal = (record) => {
  currentChangeRecord.value = record;
  changeContentModalVisible.value = true;
};

const handleChangeContentModalCancel = () => {
  changeContentModalVisible.value = false;
  currentChangeRecord.value = null;
};

//撤销变更申请
const closeChangeApply = (record) => {
  Modal.confirm({
    title: '确认撤销',
    content: '确定要撤销此牌照变更申请吗？',
    okText: '确定',
    cancelText: '取消',
    onOk() {
      console.log("closeChangeApply", record);
      emits('withdrawChange', record);
    }
  });
}

const plateConfirm = () => {
  if (!plateChangeRef.value.plateExpireDateStr) {
    message.error('请选择牌照到期日期');
    return;
  }

  // 如果需要，可以添加其他字段的校验
  if (!plateChangeRef.value.testCarNum) {
    message.error('请填写测试牌照');
    return;
  }

  if (!plateChangeRef.value.plateApplyDateStr) {
    message.error('请选择牌照申领日期');
    return;
  }

  if (!plateChangeRef.value.plateAttachmentUrl) {
    message.error('请上传牌照附件');
    return;
  }
  emits('plateChange', plateChangeRef.value);
  resetPlateChangeRef();
};

const plateChangeApplyColumns = [
  {
    title: "申请时间",
    dataIndex: "applyTime",
    key: "applyTime",
  },
  {
    title: "第三方机构审核意见",
    key: "checkOpinion",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
  },
];
</script>

<style lang="less" scoped>
.plate_modal_content {
  height: 400px;
  background: rgba(246, 248, 250, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 27px;

  .file_text {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #1D2129;
    padding-top: 14px;
  }
}

.modal_table {
  overflow-x: auto;
  width: 100%;
}

/deep/ .list {
  .tit {
    font-size: 16px;
    color: #1D2129;
    margin: 28px 0 22px 0;
    font-weight: 400;
  }
  .info {
    color: #636D7B;
    font-size: 14px;
    margin-bottom: 17px;
  }
  .modal_table {
    background: #F6F8FA;
    border-radius: 4px 4px 4px 4px;
    padding: 10px 27px;
    font-size: 12px;
    th {
      background: #fff !important;
      text-align: center;
      font-size: 12px;
    }
    td {
      text-align: center;
      font-size: 12px;
    }
    .alink {
      color: #186FF2;
      font-size: 12px;
    }
  }
}

.botmBtn {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  .mr10 {
    margin-right: 5%;
    margin-left: 5%;
  }
  .ml10 {
    margin-left: 5%;
  }
}

.plate-change-container {
  display: flex;
  width: 100%;
  padding: 10px 0;
  background: #fff !important;
  margin-top: 10px;
}

.plate-section {
  padding: 0 15px;
  box-sizing: border-box;
}

.original-data {
  flex: 0 0 40%; /* 左侧占35%宽度 */
}

.new-data {
  flex: 1;
}

.separator {
  width: 1px;
  background-color: #e8ebf0;
  height: 120px;
  margin: 10px 0;
  align-self: center;
}

.plate-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

/* 确保右侧表单元素与左侧值对齐 */
.new-data .plate-item .ant-input,
.new-data .plate-item .ant-picker {
  width: 100%;
  min-width: 0;
}

h3 {
  font-size: 14px;
  color: #1d2129;
  margin-bottom: 15px;
  font-weight: 500;
  text-align: center;
}

/* 调整日期选择器样式 */
/deep/ .ant-picker {
  width: 100%;
}

.label {
  width: 120px;
  text-align: right;
  margin-right: 10px;
  color: #636d7b;
  font-size: 14px;
  flex-shrink: 0;
}

.label.required::before {
  content: '*';
  color: #ff4d4f;
  margin-right: 4px;
}

// 添加车架号居左显示样式
.frame-number {
  text-align: left;
  margin-top: 8px;
  font-size: 14px;
  color: #1d2129;
  align-self: flex-start;
}

.value {
  flex: 1;
  color: #1d2129;
  font-size: 14px;
  padding-top: 4px;
  padding-bottom: 4px;
}

h3 {
  font-size: 14px;
  color: #1d2129;
  margin-bottom: 15px;
  font-weight: 500;
  text-align: center;
}
</style>